
import * as PGFuZHJvaWR4LmNvbXBvc2UucnVudGltZTpydW50aW1lPg from './androidx-compose-runtime-runtime.mjs';
import * as PG9yZy5qZXRicmFpbnMuY29tcG9zZS5hbmltYXRpb246YW5pbWF0aW9uLWNvcmU_ from './compose-multiplatform-core-compose-animation-animation-core.mjs';
import * as PG9yZy5qZXRicmFpbnMuY29tcG9zZS5hbmltYXRpb246YW5pbWF0aW9uPg from './compose-multiplatform-core-compose-animation-animation.mjs';
import * as PG9yZy5qZXRicmFpbnMuY29tcG9zZS5mb3VuZGF0aW9uOmZvdW5kYXRpb24tbGF5b3V0Pg from './compose-multiplatform-core-compose-foundation-foundation-layout.mjs';
import * as PG9yZy5qZXRicmFpbnMuY29tcG9zZS51aTp1aS1nZW9tZXRyeT4 from './compose-multiplatform-core-compose-ui-ui-geometry.mjs';
import * as PG9yZy5qZXRicmFpbnMuY29tcG9zZS51aTp1aS11bml0Pg from './compose-multiplatform-core-compose-ui-ui-unit.mjs';
import * as PG9yZy5qZXRicmFpbnMuY29tcG9zZS51aTp1aT4 from './compose-multiplatform-core-compose-ui-ui.mjs';
import * as PGtvdGxpbj4 from './kotlin-kotlin-stdlib.mjs';
import { __ALL_EXPORTS as PGFuZHJvaWR4LmNvbXBvc2UucnVudGltZTpydW50aW1lPg__ALL_EXPORTS } from './androidx-compose-runtime-runtime.mjs';
import { __ALL_EXPORTS as PG9yZy5qZXRicmFpbnMuY29tcG9zZS5hbmltYXRpb246YW5pbWF0aW9uLWNvcmU___ALL_EXPORTS } from './compose-multiplatform-core-compose-animation-animation-core.mjs';
import { __ALL_EXPORTS as PG9yZy5qZXRicmFpbnMuY29tcG9zZS5hbmltYXRpb246YW5pbWF0aW9uPg__ALL_EXPORTS } from './compose-multiplatform-core-compose-animation-animation.mjs';
import { __ALL_EXPORTS as PG9yZy5qZXRicmFpbnMuY29tcG9zZS5mb3VuZGF0aW9uOmZvdW5kYXRpb24tbGF5b3V0Pg__ALL_EXPORTS } from './compose-multiplatform-core-compose-foundation-foundation-layout.mjs';
import { __ALL_EXPORTS as PG9yZy5qZXRicmFpbnMuY29tcG9zZS51aTp1aS1nZW9tZXRyeT4__ALL_EXPORTS } from './compose-multiplatform-core-compose-ui-ui-geometry.mjs';
import { __ALL_EXPORTS as PG9yZy5qZXRicmFpbnMuY29tcG9zZS51aTp1aS11bml0Pg__ALL_EXPORTS } from './compose-multiplatform-core-compose-ui-ui-unit.mjs';
import { __ALL_EXPORTS as PG9yZy5qZXRicmFpbnMuY29tcG9zZS51aTp1aT4__ALL_EXPORTS } from './compose-multiplatform-core-compose-ui-ui.mjs';
import { __ALL_EXPORTS as PGtvdGxpbj4__ALL_EXPORTS } from './kotlin-kotlin-stdlib.mjs';
import { __TAG as wasmTag, getCachedJsObject } from './kotlin-kotlin-stdlib.mjs'

// Placed here to give access to it from externals (js_code)
let wasmExports;

if (typeof process !== 'undefined' && process.release.name === 'node') {
    function doNotUseRequire() {
        throw new Error("Do not use top-level require. Prefer to use JS import or define your own require instead. Read more: https://kotl.in/r9txlt")
    }

    var require = new Proxy((function() {}), {
        apply(target, thisArg, argumentsList) {
            if (globalThis.require != null) {
                return globalThis.require.apply(thisArg, argumentsList);
            } else {
                doNotUseRequire();
            }
        },
        get(target, prop, receiver) {
            if (globalThis.require != null) {
                return Reflect.get(globalThis.require, prop);
            } else {
                doNotUseRequire();
            }
        },
    });
}

export function setWasmExports(exports) {
    wasmExports = exports;
}

const js_code = {

}

const StringConstantsProxy = new Proxy({}, {
  get(_, prop) { return prop; }
});

export const importObject = {
    js_code,
    intrinsics: {

        tag: wasmTag
    },
    "'": StringConstantsProxy,
    '<androidx.compose.runtime:runtime>': PGFuZHJvaWR4LmNvbXBvc2UucnVudGltZTpydW50aW1lPg__ALL_EXPORTS,
    '<kotlin>': PGtvdGxpbj4__ALL_EXPORTS,
    '<org.jetbrains.compose.animation:animation>': PG9yZy5qZXRicmFpbnMuY29tcG9zZS5hbmltYXRpb246YW5pbWF0aW9uPg__ALL_EXPORTS,
    '<org.jetbrains.compose.animation:animation-core>': PG9yZy5qZXRicmFpbnMuY29tcG9zZS5hbmltYXRpb246YW5pbWF0aW9uLWNvcmU___ALL_EXPORTS,
    '<org.jetbrains.compose.ui:ui-unit>': PG9yZy5qZXRicmFpbnMuY29tcG9zZS51aTp1aS11bml0Pg__ALL_EXPORTS,
    '<org.jetbrains.compose.ui:ui-geometry>': PG9yZy5qZXRicmFpbnMuY29tcG9zZS51aTp1aS1nZW9tZXRyeT4__ALL_EXPORTS,
    '<org.jetbrains.compose.ui:ui>': PG9yZy5qZXRicmFpbnMuY29tcG9zZS51aTp1aT4__ALL_EXPORTS,
    '<org.jetbrains.compose.foundation:foundation-layout>': PG9yZy5qZXRicmFpbnMuY29tcG9zZS5mb3VuZGF0aW9uOmZvdW5kYXRpb24tbGF5b3V0Pg__ALL_EXPORTS,
};
    